module.exports = __webpack_public_path__ + "img/99ca00099f5d4ff7be64c79d71eba1d3-60.d78f2603.png";